export default __webpack_public_path__ + "static/docs/platform-tos.2720c543b6c456ac0962396d0d8ac375.html";